import type { ChangeEvent } from 'react'

interface FilterTagProps {
  id: string
  name: string
  value: string
  label: string
  checked: boolean
  onChange: (event: ChangeEvent<HTMLInputElement>) => void
}

export default function FilterTag({
  id,
  name,
  value,
  label,
  checked,
  onChange
}: FilterTagProps) {
  return (
    <div>
      <input
        id={id}
        type="checkbox"
        className="btn-check"
        name={name}
        value={value}
        checked={checked}
        onChange={onChange}
        autoComplete="off"
      />
      <label className="btn filter-tag-button" htmlFor={id}>
        {label}
      </label>
    </div>
  )
}
